import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';
import backgroundImage from '../assets/basketball-bg.jpg';
import { useMediaQuery } from 'react-responsive';
import MobileContact from './mobile/MobileContact';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const Contact = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  useScrollAnimation([]);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('sending');

    try {
      const templateParams = {
        from_name: formData.name,
        from_email: formData.email,
        subject: formData.subject,
        message: formData.message,
        to_email: 'basketballculturepodcast@gmail.com'
      };

      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID || '',
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '',
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY || ''
      );

      setStatus('success');
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      console.error('Error sending email:', error);
      setStatus('error');
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  if (isMobile) {
    return <MobileContact />;
  }

  return (
    <div className="contact-page">
      <div 
        className="contact-hero"
        style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.8), rgba(0,0,0,0.8)), url(${backgroundImage})` }}
      >
        <h1 className="contact-title scroll-animate">
          CONTACT<span>US</span>
        </h1>
      </div>

      <div className="contact-content">
        <div className="contact-container">
          <div className="contact-info scroll-animate">
            <h2>Get In Touch</h2>
            <p>Have questions or want to be featured on the podcast? Reach out to us!</p>
            
            <div className="contact-details">
              <div className="contact-item scroll-animate">
                <i className="fas fa-envelope"></i>
                <span>basketballculturepodcast@gmail.com</span>
              </div>
              <div className="contact-item scroll-animate">
                <i className="fas fa-map-marker-alt"></i>
                <span>Sydney, Australia</span>
              </div>
            </div>
          </div>

          <form className="contact-form scroll-animate" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <textarea
                name="message"
                placeholder="Your Message"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <button 
              type="submit" 
              className={`submit-button ${status === 'sending' ? 'sending' : ''}`}
              disabled={status === 'sending'}
            >
              {status === 'sending' ? 'Sending...' : 'Send Message'} {status !== 'sending' && <i className="fas fa-paper-plane"></i>}
            </button>
            {status === 'success' && (
              <div className="success-message">Message sent successfully!</div>
            )}
            {status === 'error' && (
              <div className="error-message">Failed to send message. Please try again.</div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact; 